var React = require('react');

function Triangle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M233.977 0.99855L0.404205 434.778H467.551L233.977 0.99855Z","fill":"currentColor"}));
}

Triangle.defaultProps = {"viewBox":"0 0 468 435","fill":"none"};

module.exports = Triangle;

Triangle.default = Triangle;
